import { SubstitutoMatriculaRapidaDTO } from '../documentacao/substitutoMatriculaRapidaDTO';
import { ConfiguracaoDocumentoDTO } from './../documentacao/configuracaoDocumentoDTO';

export class DocumentoMatriculaRapidaDTO{

    id!: number;
    configuracaoDocumento!: ConfiguracaoDocumentoDTO;
    substitutos!: SubstitutoMatriculaRapidaDTO[];    
}